import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.history');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-history',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.history/view.scss */
:host {
  --history-canvas: rgb(247 247 245);
  --history-surface: rgb(255 255 255);
  --history-label: rgb(28 28 30);
  --history-secondary: rgb(99 99 102);
  --history-tertiary: rgb(142 142 147);
  --history-separator: rgb(60 60 67 / .16);
  --history-blue: rgb(28 28 30);
  --history-red: rgb(255 59 48);
  --history-orange: rgb(201 92 0);
  position: relative;
  display: block;
  min-height: 100%;
  overflow-x: clip;
  background: var(--history-canvas);
  color: var(--history-label);
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Pretendard", sans-serif;
}

.history-page {
  position: relative;
  z-index: 1;
  container-type: inline-size;
}

.history-loading-group,
.history-state {
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1.2rem;
  background: var(--history-surface);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 20px 46px rgba(15, 23, 42, 0.065);
}

.history-stack {
  display: block;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1.2rem;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 24px 56px rgba(15, 23, 42, 0.075);
}

.history-loading-row {
  position: relative;
  height: 4.75rem;
  animation: history-pulse 1.25s ease-in-out infinite alternate;
}

.history-loading-row::after {
  position: absolute;
  top: 1.2rem;
  right: 1rem;
  bottom: 1.2rem;
  left: 1rem;
  border-radius: 0.65rem;
  background: rgba(120, 120, 128, 0.1);
  content: "";
}

.history-loading-row + .history-loading-row {
  border-top: 1px solid var(--history-separator);
}

.history-state {
  display: flex;
  min-height: 9rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  text-align: center;
}

.history-state p {
  color: var(--history-secondary);
  font-size: 0.88rem;
  font-weight: 600;
}

.history-primary-action {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1.15rem;
  border-radius: 0.72rem;
  background: #18181b;
  color: white;
  font-size: 0.82rem;
  font-weight: 700;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.history-primary-action:hover {
  opacity: 0.9;
}

.history-primary-action:active {
  transform: scale(0.98);
}

.draw-card {
  position: relative;
  overflow: hidden;
  background: #fff;
  transition: background-color 0.2s ease;
}

.draw-card + .draw-card {
  border-top: 1px solid #ececea;
}

.draw-card-open {
  background: #fbfbfa;
}

.draw-toggle {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  min-height: 4.6rem;
  align-items: center;
  gap: 0.8rem;
  padding: 0.68rem 0.8rem 0.68rem 1rem;
  color: var(--history-label);
  transition: background-color 0.2s ease;
}

.draw-toggle:hover {
  background: #f8f8f6;
}

.draw-toggle:active {
  background: rgba(120, 120, 128, 0.06);
}

.draw-card-open .draw-toggle {
  background: #fff;
}

.draw-toggle:focus-visible,
.generation-trigger:focus-visible,
.batch-modal-delete:focus-visible,
.batch-modal-close:focus-visible,
.history-more-button:focus-visible,
.history-primary-action:focus-visible {
  outline: 3px solid rgba(0, 122, 255, 0.3);
  outline-offset: -3px;
}

.draw-summary {
  min-width: 0;
}

.draw-summary h2 {
  overflow: hidden;
  color: var(--history-label);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.draw-summary-meta {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.18rem;
  color: var(--history-secondary);
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  line-height: 1.35;
  white-space: nowrap;
}

.draw-toggle-side {
  display: flex;
  align-items: center;
  gap: 0.58rem;
}

.draw-result-stack {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 0.1rem;
  text-align: right;
}

.draw-result-label {
  display: inline-flex;
  min-height: 1.65rem;
  align-items: center;
  padding: 0.2rem 0.45rem;
  border: 0;
  border-radius: 9999px;
  background: transparent;
  color: var(--history-secondary);
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.draw-result-label::before {
  width: 0.35rem;
  height: 0.35rem;
  margin-right: 0.35rem;
  border-radius: 9999px;
  background: currentColor;
  content: "";
}

.draw-result-stack strong {
  color: var(--history-red);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.draw-result-winning {
  color: var(--history-red);
}

.draw-result-pending {
  color: var(--history-orange);
}

.draw-result-complete {
  color: var(--history-secondary);
}

.draw-chevron {
  display: inline-flex;
  width: 1.55rem;
  height: 1.55rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: rgb(142, 142, 147);
  transition: transform 0.24s cubic-bezier(0.2, 0.8, 0.2, 1), background-color 0.2s ease;
}

.draw-chevron svg {
  width: 1rem;
  height: 1rem;
}

.draw-chevron-open {
  color: var(--history-label);
  transform: rotate(90deg);
}

.draw-detail {
  padding: 0.8rem;
  border-top: 1px solid #ececea;
  background: #f7f7f5;
  animation: draw-detail-enter 0.28s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.official-result {
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.075);
  border-radius: 0.9rem;
  background: #fff;
  box-shadow: inset 0 1px 0 rgb(255, 255, 255), 0 1px 3px rgba(15, 23, 42, 0.035);
}

.official-result {
  margin-bottom: 0.75rem;
  padding: 0.9rem;
}

.official-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.8rem;
}

.official-result h3 {
  color: var(--history-label);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.match-legend {
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  color: var(--history-tertiary);
  font-size: 0.66rem;
  font-weight: 600;
  white-space: nowrap;
}

.match-legend i {
  display: inline-block;
  width: 0.45rem;
  height: 0.45rem;
  border: 1.5px solid var(--history-label);
  border-radius: 9999px;
}

.official-number-rail,
.combination-numbers {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
}

.official-number-rail {
  gap: 0.42rem;
}

.official-ball,
.official-bonus,
.history-ball {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  letter-spacing: -0.02em;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 3px 8px rgba(15, 23, 42, 0.12);
}

.official-ball,
.official-bonus {
  width: 2rem;
  height: 2rem;
  font-size: 0.7rem;
}

.official-ball,
.history-ball {
  border-radius: 9999px;
}

.official-plus {
  color: var(--history-tertiary);
  font-size: 0.75rem;
  font-weight: 600;
}

.official-bonus {
  border: 1px solid rgba(255, 59, 48, 0.72);
  border-radius: 0.58rem;
  background: #fff7f7;
  color: rgb(215, 0, 21);
  box-shadow: 0 2px 7px rgba(255, 59, 48, 0.09);
}

.history-ball-yellow {
  background: #fbbf24;
  color: #172033;
}

.history-ball-blue {
  background: #3b82f6;
  color: #fff;
}

.history-ball-red {
  background: #ef4444;
  color: #fff;
}

.history-ball-gray {
  background: #64748b;
  color: #fff;
}

.history-ball-green {
  background: #10b981;
  color: #fff;
}

.draw-prize-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.85rem;
  padding-top: 0.8rem;
  border-top: 1px solid var(--history-separator);
  text-align: center;
}

.draw-prize-summary div {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
}

.draw-prize-summary span {
  color: var(--history-secondary);
  font-size: 0.68rem;
  font-weight: 600;
}

.draw-prize-summary strong {
  color: var(--history-red);
  font-size: 0.76rem;
  font-weight: 700;
}

.draw-prize-summary i {
  width: 1px;
  height: 0.9rem;
  background: var(--history-separator);
}

.generation-stack {
  display: block;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.075);
  border-radius: 0.9rem;
  background: #fff;
}

.generation-trigger {
  display: flex;
  min-width: 0;
  min-height: 3.15rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.62rem 0.75rem 0.62rem 0.9rem;
  border: 0;
  background: #fff;
  text-align: left;
  transition: background-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.generation-trigger + .generation-trigger {
  border-top: 1px solid #ececea;
}

.generation-trigger:hover {
  background: #f8f8f6;
}

.generation-trigger:active {
  background: rgba(242, 242, 245, 0.82);
  box-shadow: inset 0 1px 3px rgba(45, 55, 78, 0.055);
  transform: scale(0.994);
}

.generation-trigger-copy {
  display: flex;
  min-width: 0;
  align-items: baseline;
}

.generation-time {
  color: var(--history-label);
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.generation-count {
  margin-left: 0.4rem;
  color: var(--history-tertiary);
  font-size: 0.7rem;
  font-weight: 600;
}

.generation-trigger-side {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.22rem;
  color: var(--history-secondary);
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}

.generation-trigger-side svg {
  width: 0.9rem;
  height: 0.9rem;
}

.delete-spinner {
  width: 0.9rem;
  height: 0.9rem;
  border: 2px solid rgba(255, 59, 48, 0.2);
  border-top-color: var(--history-red);
  border-radius: 9999px;
  animation: history-spin 0.7s linear infinite;
}

.combination-list {
  display: block;
}

.combination-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  min-width: 0;
  min-height: 3.2rem;
  align-items: center;
  gap: 0.45rem;
  padding: 0.52rem 0.6rem;
  transition: background-color 0.14s ease;
}

.combination-row + .combination-row {
  border-top: 1px solid var(--history-separator);
}

.combination-row:hover {
  background: rgba(120, 120, 128, 0.045);
}

.combination-row-pending {
  grid-template-columns: minmax(0, 1fr);
}

.combination-row-pending .combination-numbers {
  width: 100%;
  justify-content: center;
  justify-self: stretch;
}

.combination-numbers {
  width: auto;
  justify-content: flex-start;
  justify-self: start;
  gap: clamp(0.12rem, 0.8vw, 0.42rem);
  overflow: visible;
}

.history-ball {
  width: clamp(1.35rem, (100vw - 8rem) / 6, 1.95rem);
  height: clamp(1.35rem, (100vw - 8rem) / 6, 1.95rem);
  font-size: clamp(0.55rem, 2vw, 0.68rem);
  transition: box-shadow 0.16s ease, transform 0.16s ease, border-radius 0.16s ease;
}

.history-ball.winning-number-match {
  box-shadow: 0 0 0 2px white, 0 0 0 3.5px rgba(28, 28, 30, 0.82);
  transform: scale(1.02);
}

.history-ball.bonus-number-match {
  border-radius: 0.55rem;
  box-shadow: 0 0 0 2px white, 0 0 0 3.5px rgba(255, 59, 48, 0.88);
  transform: scale(1.02);
}

.combination-result {
  display: inline-flex;
  min-height: 1.72rem;
  align-items: center;
  justify-content: center;
  justify-self: end;
  gap: 0.24rem;
  padding: 0.28rem 0.62rem;
  border: 1px solid rgba(15, 23, 42, 0.075);
  border-radius: 9999px;
  background: #f7f7f5;
  box-shadow: none;
  color: var(--history-secondary);
  white-space: nowrap;
}

.combination-result strong,
.combination-result span,
.combination-result em {
  font-weight: 600;
  letter-spacing: -0.01em;
  font-style: normal;
}

.combination-result strong {
  font-size: 0.82rem;
  font-weight: 700;
}

.combination-result span {
  font-size: 0.67rem;
}

.combination-result em {
  margin-left: 0.16rem;
  padding-left: 0.4rem;
  border-left: 1px solid currentColor;
  font-size: 0.62rem;
  opacity: 0.72;
}

.result-indicator {
  width: 0.38rem;
  height: 0.38rem;
  margin-right: 0.08rem;
  border-radius: 9999px;
  background: currentColor;
  box-shadow: 0 0 0 3px currentColor;
  opacity: 0.16;
}

.result-winning {
  border-color: rgba(255, 59, 48, 0.16);
  background: #fff5f4;
  color: var(--history-red);
}

.result-close {
  border-color: rgba(196, 161, 70, 0.2);
  background: #fff9e8;
  color: #7c5711;
}

.result-complete {
  color: var(--history-secondary);
}

.history-more-button {
  display: flex;
  min-height: 3rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border-radius: 0.9rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
  box-shadow: inset 0 1px 0 rgb(255, 255, 255), 0 2px 8px rgba(15, 23, 42, 0.04), 0 12px 30px rgba(15, 23, 42, 0.045);
  color: var(--history-label);
  font-size: 0.78rem;
  font-weight: 700;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.history-more-button:hover {
  background: rgb(250, 250, 250);
}

.history-more-button:active {
  background: rgb(235, 235, 240);
  transform: scale(0.992);
}

.history-more-button:disabled {
  color: var(--history-tertiary);
  opacity: 0.6;
}

.batch-modal-layer {
  position: fixed;
  inset: 0;
  z-index: 900;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Pretendard", sans-serif;
}

.batch-modal-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(18, 18, 20, 0.4);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  animation: batch-backdrop-in 0.18s ease-out both;
}

.batch-modal-viewport {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
  pointer-events: none;
}

.batch-modal-panel {
  display: flex;
  width: 100%;
  max-height: calc(100dvh - 0.5rem);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-bottom: 0;
  border-radius: 1.5rem 1.5rem 0 0;
  background: #f7f7f5;
  box-shadow: inset 0 1px 0 white, 0 -24px 64px rgba(0, 0, 0, 0.18);
  pointer-events: auto;
  animation: batch-sheet-in 0.28s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.batch-sheet-handle {
  width: 2.25rem;
  height: 0.27rem;
  flex: 0 0 auto;
  margin: 0.48rem auto 0.12rem;
  border-radius: 9999px;
  background: rgba(142, 142, 147, 0.42);
}

.batch-modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.8rem 0.8rem 1rem;
  border-bottom: 1px solid var(--history-separator);
}

.batch-modal-heading {
  min-width: 0;
}

.batch-modal-heading h2 {
  color: var(--history-label);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.batch-modal-heading p {
  overflow: hidden;
  margin-top: 0.12rem;
  color: var(--history-secondary);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.batch-modal-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.42rem;
}

.batch-modal-delete,
.batch-modal-close {
  display: inline-flex;
  width: 2.35rem;
  height: 2.35rem;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 9999px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.batch-modal-delete {
  background: #fff5f4;
  color: var(--history-red);
}

.batch-modal-close {
  background: #fff;
  color: var(--history-secondary);
}

.batch-modal-delete:hover {
  background: rgba(255, 225, 222, 0.9);
}

.batch-modal-close:hover {
  background: rgba(255, 255, 255, 0.95);
}

.batch-modal-delete:active,
.batch-modal-close:active {
  transform: scale(0.96);
}

.batch-modal-delete:disabled,
.batch-modal-close:disabled {
  opacity: 0.45;
  transform: none;
}

.batch-modal-delete svg,
.batch-modal-close svg {
  width: 1.05rem;
  height: 1.05rem;
}

.batch-modal-body {
  min-height: 0;
  overflow-y: auto;
  padding: 0.75rem 0.75rem max(1rem, env(safe-area-inset-bottom));
  overscroll-behavior: contain;
}

.batch-modal-list {
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0.95rem;
  background: #fff;
  box-shadow: inset 0 1px 0 white, 0 2px 8px rgba(15, 23, 42, 0.04), 0 14px 34px rgba(15, 23, 42, 0.045);
}

.batch-modal-note {
  margin: 0.7rem 0 0;
  color: var(--history-secondary);
  font-size: 0.72rem;
  font-weight: 600;
  text-align: center;
}

@keyframes history-pulse {
  from {
    opacity: 0.55;
  }
  to {
    opacity: 1;
  }
}
@keyframes draw-detail-enter {
  from {
    opacity: 0;
    transform: translateY(-0.15rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes history-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes batch-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes batch-sheet-in {
  from {
    opacity: 0.7;
    transform: translateY(2rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 767px) {
  .batch-modal-layer {
    bottom: calc(4rem + max(0.5rem, env(safe-area-inset-bottom)));
  }
}
@media (max-width: 639px) {
  .batch-modal-viewport {
    padding: 0 0.5rem 0.5rem;
  }
  .batch-modal-panel {
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 1.5rem;
  }
}
@media (min-width: 640px) {
  .draw-toggle {
    min-height: 5rem;
    padding-right: 1rem;
    padding-left: 1.15rem;
  }
  .draw-detail {
    padding: 1rem;
  }
  .official-result {
    padding: 1rem;
  }
  .official-number-rail {
    gap: 0.58rem;
  }
  .official-ball,
  .official-bonus {
    width: 2.15rem;
    height: 2.15rem;
    font-size: 0.73rem;
  }
  .combination-numbers {
    gap: 0.53rem;
  }
  .history-ball {
    width: 2.08rem;
    height: 2.08rem;
    font-size: 0.72rem;
  }
  .batch-modal-viewport {
    align-items: center;
    padding: 1rem;
  }
  .batch-modal-panel {
    width: min(100%, 34rem);
    max-height: min(42rem, 100dvh - 2rem);
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 1.5rem;
    box-shadow: inset 0 1px 0 white, 0 28px 80px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.08);
    animation-name: batch-modal-in;
  }
  .batch-sheet-handle {
    display: none;
  }
  .batch-modal-header {
    padding: 1rem 1rem 1rem 1.15rem;
  }
  .batch-modal-body {
    padding: 0.9rem 1rem 1rem;
  }
}
@media (min-width: 768px) {
  .draw-detail {
    padding: 1.1rem;
  }
}
@media (max-width: 370px) {
  .draw-toggle {
    gap: 0.55rem;
    padding-right: 0.7rem;
    padding-left: 0.8rem;
  }
  .draw-toggle-side {
    gap: 0.35rem;
  }
  .draw-result-label {
    font-size: 0.68rem;
  }
  .history-ball {
    width: clamp(1.35rem, (100vw - 7rem) / 6, 1.6rem);
    height: clamp(1.35rem, (100vw - 7rem) / 6, 1.6rem);
    font-size: 0.56rem;
  }
  .combination-numbers {
    gap: 0.12rem;
  }
  .combination-row {
    gap: 0.35rem;
    padding-right: 0.35rem;
    padding-left: 0.35rem;
  }
  .combination-result {
    gap: 0.16rem;
    padding-right: 0.45rem;
    padding-left: 0.45rem;
  }
  .result-indicator {
    display: none;
  }
  .combination-result em {
    display: none;
  }
  .batch-modal-body {
    padding-right: 0.4rem;
    padding-left: 0.4rem;
  }
  .official-ball,
  .official-bonus {
    width: 1.7rem;
    height: 1.7rem;
    font-size: 0.6rem;
  }
  .official-number-rail {
    gap: 0.27rem;
  }
  .match-legend {
    font-size: 0.59rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .draw-detail,
  .draw-chevron,
  .delete-spinner,
  .history-loading-row,
  .batch-modal-backdrop,
  .batch-modal-panel {
    animation: none;
    transition: none;
  }
}
@keyframes batch-modal-in {
  from {
    opacity: 0;
    transform: translateY(0.5rem) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`],
})
export class PageHistoryComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public loadingMoreDraws: boolean = false;
    public loadingDrawNo: number = 0;
    public deletingBatchId: number = 0;
    public drawGroups: any[] = [];
    public expandedDrawNo: number = 0;
    public nextDrawOffset: number = 0;
    public hasMoreDraws: boolean = false;
    public totalDrawCount: number = 0;
    public loadError: string = '';
    public selectedBatch: any = null;
    public selectedGroup: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public ngOnDestroy() {
        this.setBatchScrollLocked(false);
    }

    private setBatchScrollLocked(locked: boolean) {
        if (typeof document === 'undefined') return;
        const root = document.querySelector('app-root');
        if (root) root.classList.toggle('batch-modal-open', locked);
    }

    public async load(preserveDrawNo: number = 0) {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('history', {
                offset: 0,
                limit: 5
            });
            if (code !== 200) {
                this.loadError = data.message || '내 번호를 불러오지 못했습니다.';
                return;
            }

            this.drawGroups = data.groups || [];
            this.nextDrawOffset = Number(data.next_offset || this.drawGroups.length);
            this.hasMoreDraws = Boolean(data.has_more);
            this.totalDrawCount = Number(data.total_draw_count || 0);

            const preserved = this.drawGroups.some(
                (group: any) => group.draw_no === preserveDrawNo
            );
            this.expandedDrawNo = preserved
                ? preserveDrawNo
                : Number(this.drawGroups[0]?.draw_no || 0);
        } catch (error) {
            this.loadError = '연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadMoreDraws() {
        if (this.loadingMoreDraws || !this.hasMoreDraws) return;
        this.loadingMoreDraws = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('history', {
                offset: this.nextDrawOffset,
                limit: 5
            });
            if (code !== 200) {
                await this.service.modal.error(
                    data.message || '이전 회차를 불러오지 못했습니다.'
                );
                return;
            }

            const known = new Set(this.drawGroups.map((group: any) => group.draw_no));
            const additional = (data.groups || []).filter(
                (group: any) => !known.has(group.draw_no)
            );
            this.drawGroups = [...this.drawGroups, ...additional];
            this.nextDrawOffset = Number(data.next_offset || this.drawGroups.length);
            this.hasMoreDraws = Boolean(data.has_more);
            this.totalDrawCount = Number(data.total_draw_count || this.totalDrawCount);
        } catch (error) {
            await this.service.modal.error('연결을 확인한 뒤 다시 시도해주세요.');
        } finally {
            this.loadingMoreDraws = false;
            await this.service.render();
        }
    }

    public async loadMoreBatches(group: any) {
        if (this.loadingDrawNo || !group?.has_more_batches) return;
        this.loadingDrawNo = group.draw_no;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('history_draw', {
                draw_no: group.draw_no,
                offset: group.next_batch_offset || group.batches?.length || 0,
                limit: 5
            });
            if (code !== 200) {
                await this.service.modal.error(
                    data.message || '생성 기록을 더 불러오지 못했습니다.'
                );
                return;
            }

            const known = new Set(
                (group.batches || []).map((batch: any) => batch.batch_id)
            );
            group.batches = [
                ...(group.batches || []),
                ...(data.batches || []).filter(
                    (batch: any) => !known.has(batch.batch_id)
                )
            ];
            group.next_batch_offset = Number(
                data.next_offset || group.batches.length
            );
            group.has_more_batches = Boolean(data.has_more);
        } catch (error) {
            await this.service.modal.error('연결을 확인한 뒤 다시 시도해주세요.');
        } finally {
            this.loadingDrawNo = 0;
            await this.service.render();
        }
    }

    public async remove(batch: any, group: any) {
        if (this.deletingBatchId) return;
        const confirmed = await this.service.modal.show({
            title: '생성 기록 삭제',
            message: `제 ${group.draw_no}회 ${this.createdDate(batch.created_at)} 기록을 삭제할까요?`,
            cancel: true,
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        this.deletingBatchId = batch.batch_id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_history', {
                batch_id: batch.batch_id
            });

            if (code === 200) {
                this.deletingBatchId = 0;
                this.selectedBatch = null;
                this.selectedGroup = null;
                this.setBatchScrollLocked(false);
                await this.load(group.draw_no);
                return;
            }

            this.deletingBatchId = 0;
            await this.service.modal.error(data.message || '삭제하지 못했습니다.');
        } catch (error) {
            this.deletingBatchId = 0;
            await this.service.modal.error('연결을 확인한 뒤 다시 시도해주세요.');
        }
        await this.service.render();
    }

    public async toggleDraw(group: any) {
        this.expandedDrawNo = this.expandedDrawNo === group.draw_no
            ? 0
            : group.draw_no;
        await this.service.render();
    }

    public isExpanded(group: any) {
        return this.expandedDrawNo === group.draw_no;
    }

    public async openBatchModal(batch: any, group: any) {
        this.selectedBatch = batch;
        this.selectedGroup = group;
        this.setBatchScrollLocked(true);
        await this.service.render();
    }

    public async closeBatchModal() {
        if (this.deletingBatchId) return;
        this.selectedBatch = null;
        this.selectedGroup = null;
        this.setBatchScrollLocked(false);
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async onEscape() {
        if (!this.selectedBatch) return;
        await this.closeBatchModal();
    }

    public batchHasPendingResults(batch: any) {
        return (batch?.set_details || []).some((item: any) => !item?.evaluated);
    }

    public drawResultLabel(group: any) {
        if (Number(group?.winning_set_count || 0) > 0) {
            return `${group.winning_set_count}조합 당첨`;
        }
        if (Number(group?.pending_set_count || 0) > 0) return '추첨 전';
        return `최고 ${Number(group?.best_matched_count || 0)}개 일치`;
    }

    public drawResultClass(group: any) {
        if (Number(group?.winning_set_count || 0) > 0) {
            return 'draw-result-winning';
        }
        if (Number(group?.pending_set_count || 0) > 0) {
            return 'draw-result-pending';
        }
        return 'draw-result-complete';
    }

    public resultValue(item: any) {
        if (Number(item?.prize_rank || 0) > 0) {
            return String(item.prize_rank);
        }
        return String(Number(item?.matched_count || 0));
    }

    public resultUnit(item: any) {
        return Number(item?.prize_rank || 0) > 0 ? '등 당첨' : '개 일치';
    }

    public resultSecondary(item: any) {
        if (!item?.evaluated || Number(item?.prize_rank || 0) < 1) return '';
        return `${Number(item.prize_amount || 0).toLocaleString('ko-KR')}원`;
    }

    public resultAriaLabel(item: any) {
        const result = `${this.resultValue(item)}${this.resultUnit(item)}`;
        const amount = this.resultSecondary(item);
        return amount ? `${result}, ${amount}` : result;
    }

    public resultPanelClass(item: any) {
        if (Number(item?.prize_rank || 0) > 0) return 'result-winning';
        if (Number(item?.matched_count || 0) >= 4) return 'result-close';
        return 'result-complete';
    }

    public numberMatchClass(number: number, item: any, group: any) {
        if (!item?.evaluated) return '';
        if (
            item?.bonus_matched
            && Number(number) === Number(group?.bonus_number)
        ) {
            return 'bonus-number-match';
        }
        if ((group?.winning_numbers || []).includes(Number(number))) {
            return 'winning-number-match';
        }
        return '';
    }

    public numberAriaLabel(number: number, item: any, group: any) {
        const matchClass = this.numberMatchClass(number, item, group);
        if (matchClass === 'bonus-number-match') return `${number}, 보너스 번호 일치`;
        if (matchClass === 'winning-number-match') return `${number}, 당첨번호 일치`;
        return String(number);
    }

    public numberClass(number: number) {
        if (number <= 10) return 'history-ball-yellow';
        if (number <= 20) return 'history-ball-blue';
        if (number <= 30) return 'history-ball-red';
        if (number <= 40) return 'history-ball-gray';
        return 'history-ball-green';
    }

    public createdDate(value: any) {
        const source = String(value || '').trim();
        if (!source) return '';
        const normalized = source.includes('T')
            ? source
            : source.replace(' ', 'T');
        const zoned = /(?:Z|[+-]\d{2}:?\d{2})$/.test(normalized)
            ? normalized
            : `${normalized}Z`;
        const date = new Date(zoned);
        if (Number.isNaN(date.getTime())) return source.slice(0, 16);
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
        }).format(date);
    }

    public drawDate(value: any) {
        const parts = String(value || '').split('-').map(Number);
        if (parts.length !== 3 || parts.some((part: number) => !part)) return '';
        return `${parts[0]}. ${parts[1]}. ${parts[2]}.`;
    }

    public formatAmount(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public remainingDrawCount() {
        return Math.max(0, this.totalDrawCount - this.drawGroups.length);
    }

    public trackByDrawNo(index: number, group: any) {
        return group.draw_no;
    }

    public trackByBatchId(index: number, batch: any) {
        return batch.batch_id;
    }
}

export default PageHistoryComponent;